export class Areas {
    public id: string;
    public area: string;
    public restricted: boolean;
}